import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class ParcelasListsDefinition {
    public fincas: TypeAheadInterface<FincasModel> = list();
    public sectores: TypeAheadInterface<SectorModel> = list();
    public cultivos: TypeAheadInterface<VisitasVariedadMesModel> = list();
    public variedades: TypeAheadInterface<VisitasVariedadMesModel> = list();
    public cultivosLegacy: TypeAheadInterface<VisitasVariedadMesModel> = list();
    public variedadesLegacy: TypeAheadInterface<VisitasVariedadMesModel> = list();
    public comercios: TypeAheadInterface<Compradores> = list();
    public aplicadores: TypeAheadInterface<MantenimientoModel[]> = list();

    public secanoRegadio: TypeAheadInterface<string> = list(
        ['...', null],
        ['Secano', 'S'],
        ['Regadío', 'R']
    );
    public sistemasRiego: TypeAheadInterface<string> = list();

    public usoSigpac: TypeAheadInterface<string> = list(
        ['...', null],
        ['Corrientes y superficies de agua (AG)', 'AG'],
        ['Viales (CA)', 'CA'],
        ['Cítricos-Frutal (CF)', 'CF'],
        ['Cítricos (CI)', 'CI'],
        ['Cítricos-Frutal de cáscara (CS)', 'CS'],
        ['Cítricos-Viñedo (CV)', 'CV'],
        ['Edificaciones (ED)', 'ED'],
        ['Elemento del Paisaje (EP)', 'EP'],
        ['Frutal de Cáscara-Frutal (FF)', 'FF'],
        ['Frutal de Cáscara-Olivar (FL)', 'FL'],
        ['Forestal (FO)', 'FO'],
        ['Frutal de Cáscara (FS)', 'FS'],
        ['Frutal de Cáscara-Viñedo (FV)', 'FV'],
        ['Frutal (FY)', 'FY'],
        ['Improductivo (IM)', 'IM'],
        ['Invernaderos y cultivos bajo plástico (IV)', 'IV'],
        ['Olivar-Cítricos (OC)', 'OC'],
        ['Olivar-Frutal (OF)', 'OF'],
        ['Olivar (OV)', 'OV'],
        ['Pasto arbolado (PA)', 'PA'],
        ['Pasto arbustivo (PR)', 'PR'],
        ['Pastizal (PS)', 'PS'],
        ['Tierra arable (TA)', 'TA'],
        ['Huerta (TH)', 'TH'],
        ['Frutal-Viñedo (VF)', 'VF'],
        ['Viñedo (VI)', 'VI'],
        ['Olivar-Viñedo (VO)', 'VO'],
        ['Zona concentrada (ZC)', 'ZC'],
        ['Zona urbana (ZU)', 'ZU'],
        ['Zona censurada (ZV)', 'ZV']
    );

    public patron: TypeAheadInterface<string> = list(
        ['...', null]
    );

    public patronAguacate: TypeAheadInterface<string> = list(
        ['...', null],
        'Ashdot 17',
        'Clon Atkinson',
        'Clon Bounty',
        'Clon Duke-7',
        'Clon Dusa',
        'Clon Thomas',
        'Clon Toro Canyon',
        'Criollo Antillano',
        'Criollo Mexicano',
        'Dgania 117',
        'Duke-7 (Semilla)',
        'Lula',
        'Maoz',
        'Mexicola',
        'Nachar',
        'Topa-Topa',
        'Water-Hole',
        'Zutano'
    );

    public regimenTenencia: TypeAheadInterface<string> = list(
        ['...', null],
        'Propiedad',
        'Arrendamiento',
        'Aparcería',
        'Otros'
    );
    public regimenTenenciaProdalbar: TypeAheadInterface<string> = list(
        ['...', null],
        'Propiedad',
        'Arrendamiento'
    );

    public patronAlmendro: TypeAheadInterface<string> = list(
        ['...', null],
        'Franco de semilla'
    );
    public patronManzano: TypeAheadInterface<string> = list(
        ['...', null],
        // Fuji
        'Kiku',
        'Fubrax',
        'Zhen Aztec',
        'San',
        'September Wonder',
        // Gala
        'Brookfield',
        'Scniga',
        'Vinus',
        'Schnicored',
        // Golden'
        'Delicious',
        'Smoothee',
        'Reinders',
        'Parsi',
        // Granny Smith
        'Challenger',
        // Red Delicious
        'Starking',
        'Golden Rose',
        'Jeromine',
        'Scarlet Spur',
        // Reineta
        'Blanca',
        'Parda',
        // Otros patrones
        'M12',
        'M7',
        'M9',
        'MM106'
    );
    public patronMelocotoneroParaguayo: TypeAheadInterface<string> = list(
        ['...', null],
        'Franco',
        'GF677',
        'Garmen',
        'Rootpac 40',
        'Rootpac 60'
    );

    public patronMango: TypeAheadInterface<string> = list(
        ['...', null],
        '13-1',
        'Banilejo',
        'Criollo',
        'Gomera-1',
        'Gomera-3'
    );
    public patronMelocotonero: TypeAheadInterface<string> = list(
        ['...', null],
        'GF-677', 'GxN Garnem', 'Monclart'
    );
    public patronNogal: TypeAheadInterface<string> = list(
        ['...', null],
        'Juglans regia', 'Mj209 x Ra'
    );
    public patronCerezo: TypeAheadInterface<string> = list(
        ['...', null],
        'Adara', 'Avium', 'Cab6', 'Col', 'Marina-Adara', 'Maxma', 'Santa Lucía', 'Santa Lucía 64'
    );
    public patronCiruelo: TypeAheadInterface<string> = list(
        ['...', null],
        'Mariana', 'Melocotonero', 'Mirobolán C'
    );
    public patronCitricos: TypeAheadInterface<string> = list(
        ['...', null],
        'C-35', 'Carrizo', 'Citrumelo', 'Citrumelo CPB 4475', 'Cleopatra', 'Forner Alcaide',
        'Macrophylla', 'Naranjo Amargo', 'Naranjo Borde', 'Troyer', 'Volkameriana',
    );
    public patronPera: TypeAheadInterface<string> = list(
        ['...', null],
        'BA-29', 'EM-C', 'Franco', 'Membrillero'
    );
    public patronVina: TypeAheadInterface<{codigo: string;}> = list( // Portainjerto
    );

    public cama: TypeAheadInterface<string> = list( // CartagenaFresh
        ['...', null],
        ['1.80', '1.80'], ['90', '90'], ['60', '60']
    );

    public formatoMomparler: TypeAheadInterface<string> = list(
        ['...', null]
        , '104'
        , '102'
        , '40 '
        , '252'
        , '160'
        , '15 '
        , '77 '
        , '51 '
    );

    public sistemaAsesoramiento: TypeAheadInterface<string> = list(
        ['...', null],
        ['Agricultura Ecológica', 'AE'],
        ['Producción Integrada', 'PI'],
        ['Certificación Privada', 'CP'],
        ['Agrupación de Tratamiento Integrado en Agricultura', 'ATRIAS'],
        ['Asistida de un Asesor', 'AS'],
        ['Agrupación Oficial Reconocida', 'AO'],
        ['Guías de cultivo', 'GC'],
        ['Asesor individual', 'AI'],
        ['Sin obligación de aplicar la GIP', 'NO']
    );

    public sistemasCultivo: TypeAheadInterface<string> = list(
        ['...', null],
        ['Aire libre', '1'],
        ['Malla', '2'],
        ['Cubierta no accesible', '3'],
        ['Invernadero (cubierta accesible)', '4'],
        ['Forestales en rotación corta', '5'],
        ['Micorrizado', '6'],
        ['Acolchado (SG ACE)', '7'],
        ['Enarenado (SG ACE)', '8'],
        ['Bodega Sacos (Setas/champiñones)', '9'],
        ['Bodega Bandejas (Setas/champiñones)', '10'],
        ['Bodega Botellas (Setas/champiñones)', '11'],
        ['Bodega Otros (Setas/champiñones)', '12'],
        ['Nave Sacos (Setas/champiñones)', '13'],
        ['Nave Bandejas (Setas/champiñones)', '14'],
        ['Nave Botellas (Setas/champiñones)', '15'],
        ['Nave Otros (Setas/champiñones)', '16'],
        ['Hoyos (Viñedo Lanzarote)', '17'],
        ['Zanjas (Viñedo Lanzarote)', '18'],
        ['Invernadero (cubierta accesible)+ enarenado', '19'],
    );

    public observacionesForestales: TypeAheadInterface<string> = list(
        ['...', null],
        ['EUCALIPTO', '225'],
        ['PAULONIA', '200'],
        ['CHOPO', '116'],
        ['SAUCE', '227'],
        ['ROBINIA', '230'],
        ['MIMBRERA', '442'],
    );
    public uds_bandeja: TypeAheadInterface<string> = list(
        ['...', ''],
        ['84', '84'],
        ['144', '144'],
        ['240', '240'],
        ['Semillero', 'Semillero']
    );

    public tipoSiembra: TypeAheadInterface<string> = list(
        ['...', null],
        ['Siembra Directa', 'SD'],
        ['Trasplante', 'TR']
    );

    public filtroCultivosYagoAznar = ['CEBADA', 'AVENA', 'OLIVO', 'VIÑA', 'ALMENDRO', 'BARBECHO TRADICIONAL'];
}